import type { TPagination } from '@/core/types/envelope'

export const DEFAULT_PAGE = 1
export const DEFAULT_PER_PAGE = 20

export type TPaginationParams = {
  page: number
  per_page: number
}

export const defaultPagination = (): TPaginationParams => ({
  page: DEFAULT_PAGE,
  per_page: DEFAULT_PER_PAGE,
})

/**
 * Ant Design Pagination şekli için adaptör. Backend `total` vermezse
 * `total_page * per_page` üzerinden tahmin eder.
 */
export const toAntdPagination = (p: TPagination | undefined) => {
  const current = p?.page ?? DEFAULT_PAGE
  const pageSize = p?.per_page ?? DEFAULT_PER_PAGE
  const total = p?.total ?? (p?.total_page ?? 0) * pageSize
  return { current, pageSize, total }
}
